import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const ICONS = {
  "silent-retreat": "◯",
  "farm-life": "✿",
  "digital-nomad": "◉",
  "artist-sanctuary": "✎",
  "slow-adventure": "↳",
  "wellness-escape": "❋",
};

export default function VibeChips({ selected, onSelect }) {
  const [vibes, setVibes] = useState([]);

  useEffect(() => {
    api.get("/meta/vibes").then((r) => setVibes(r.data)).catch(() => setVibes([]));
  }, []);

  if (!vibes.length) return null;

  return (
    <div data-testid="vibe-chips" className="flex gap-2 overflow-x-auto pb-2 -mx-2 px-2 snap-x snap-mandatory">
      {vibes.map((v) => {
        const isActive = selected === v.id;
        return (
          <button
            key={v.id}
            type="button"
            data-testid={`vibe-chip-${v.id}`}
            onClick={() => onSelect(isActive ? null : v.id)}
            className={`snap-start shrink-0 flex items-center gap-2 rounded-full border px-4 py-2 transition-colors ${
              isActive ? "bg-terracotta text-canvas border-terracotta" : "bg-white border-subtle hover:border-terracotta"
            }`}
            title={v.description}
          >
            <span className="text-base leading-none">{ICONS[v.id] || "✦"}</span>
            <span className="text-sm font-medium">{v.label}</span>
          </button>
        );
      })}
    </div>
  );
}
